import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';

export enum ENUM__control_net_type {
  /*
   *  edge
   */
  LINE_GUIDANCE_CANNY = 'line_guidance_canny',
  LINE_GUIDANCE_LINEART_ANIME = 'line_guidance_lineart_anime',
  LINE_GUIDANCE_LINEART = 'line_guidance_lineart',
  LINE_GUIDANCE_MLSD = 'line_guidance_mlsd',
  LINE_GUIDANCE_HED = 'line_guidance_hed',
  LINE_GUIDANCE_SCRIBBLE = 'line_guidance_scribble',
  LINE_GUIDANCE_SOFT = 'line_guidance_soft',

  /*
   *  other
   */
  DEPTH = 'depth',
  INPAINT = 'inpaint',
  NORMAL_MAP = 'normal_map',
  POSE = 'pose',
  PIX2PIX = 'pix2pix',
  SEMANTIC_SEGMENTATION = 'semantic_segmentation',
  SHUFFLE = 'shuffle',
  TILE = 'tile',
}

const ENUM_CN = ENUM__control_net_type;
const ENUM_IA = ENUM__image_asset_category;

export namespace ENUM_UTILS__control_net_type {
  export function get_image_category_for(type: ENUM__control_net_type): ENUM__image_asset_category {
    let out_map = new Map<ENUM__control_net_type, ENUM__image_asset_category>([
      [ENUM_CN.LINE_GUIDANCE_CANNY, ENUM_IA.LINE__CANNY],
      //
      [ENUM_CN.LINE_GUIDANCE_LINEART_ANIME, ENUM_IA.LINE__LINEART],
      [ENUM_CN.LINE_GUIDANCE_LINEART, ENUM_IA.LINE__LINEART],
      //
      [ENUM_CN.LINE_GUIDANCE_MLSD, ENUM_IA.LINE__MLSD],
      //
      [ENUM_CN.LINE_GUIDANCE_HED, ENUM_IA.LINE__SOFT_EDGE],
      [ENUM_CN.LINE_GUIDANCE_SOFT, ENUM_IA.LINE__SOFT_EDGE],
      //
      [ENUM_CN.LINE_GUIDANCE_SCRIBBLE, ENUM_IA.LINE__SCRIBBLE],
      //
      [ENUM_CN.DEPTH, ENUM_IA.DEPTH],
      //
    ]);

    let out = out_map.get_or_assert(type);

    return out;
  }
}
